import { ADMIN_FLASH } from '../../constants/actions';

export function closeFlash() {
    return {
        type: ADMIN_FLASH.CLOSE
    };
}

export function openFlash(message, flashType = 'success') {
    return { type: ADMIN_FLASH.OPEN, flashType: flashType, message: message };
}



// WEBPACK FOOTER //
// ./src/actions/admin/flash.js